import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import { LoginCallback } from '@okta/okta-react'

import Home from './Home'

import App from './App.jsx'
import { getAPIServerByENV } from './utilityFunctions.js'
import styles from './scss/Home.module.scss'

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    loader: async () => {
      await getAPIServerByENV()

      return null
    },
    children: [
      { index: true, element: <Home /> },
      {
        path: '/okta/callback',
        element: (
          <div className={styles.wrapper} style={{ alignItems: 'center', paddingTop: '7%' }}>
            <LoginCallback />
          </div>
        ),
      },
    ],
  },
  { path: '*', element: <Navigate to='/' /> },
])

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <RouterProvider router={router} fallbackElement={<App />} />
  </StrictMode>
)
